import { render, staticRenderFns } from "./leaveMessage.vue?vue&type=template&id=702cc6c6&scoped=true&"
import script from "./leaveMessage.vue?vue&type=script&lang=js&"
export * from "./leaveMessage.vue?vue&type=script&lang=js&"
import style0 from "./leaveMessage.vue?vue&type=style&index=0&id=702cc6c6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "702cc6c6",
  null
  
)

export default component.exports